import { Card, CheckmarkIcon, Title } from 'internalLibrary';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import layout from '../../../../../scss/layout.module.scss';
import style from './FDFApplied.module.scss';
import useClientQuery from 'ui/hooks/useClientQuery';

const FDFApplied: FC = () => {
  const { t } = useTranslation();
  const { data: clientData } = useClientQuery();
  const account = clientData?.bankAccount;
  const accountEnding = account?.slice(-4) || 'XXXX';

  return (
    <div className={layout['width-lg']}>
      <Title
        icon={<CheckmarkIcon />}
        text={t('fdfApplied_title')}
        className={style.title}
      />

      <Card className={style.card}>
        <Card intent="success" className={style['inner-card']}>
          <span
            className={style['card-main-text']}
            dangerouslySetInnerHTML={{
              __html: t('fdfApplied_card_top'),
            }}
          />
          <hr className={style.divider} />
          <div className={style['card-bottom-text']}>
            {t('fdfApplied_card_bottom')}
          </div>
          <div className={style['bank-account']}>
            XXXX-XXXXXXX{accountEnding}
          </div>
        </Card>
      </Card>
    </div>
  );
};

export default FDFApplied;
